import React from 'react';
import { Calendar, momentLocalizer } from 'react-big-calendar';
import moment from 'moment';
import DatePicker from 'react-datepicker';

import withStyles from '@material-ui/core/styles/withStyles';
import ModalRoot from 'components/Modal/ModalRoot';
import Button from '@material-ui/core/Button';

import Fab from '@material-ui/core/Fab';
import { MdAdd } from 'react-icons/md';
import GamesTable from './GamesTable';
import LeagueTeamSorting from 'templates/common/LeagueTeamSorting';
import { Progress } from 'components';
import Dropzone from 'react-dropzone';
import UploadIcon from '@material-ui/icons/CloudUploadOutlined';
import { BsFillXCircleFill as RemoveIcon } from 'react-icons/bs';
import { store } from 'store/createStore';
import { BASE_URL } from 'consts';
import Request from 'superagent';
import _ from 'lodash';

import EditGameDialog from '../Games/EditGameDialog';

import 'rc-time-picker/assets/index.css';
import 'react-big-calendar/lib/css/react-big-calendar.css';
import 'react-datepicker/dist/react-datepicker.css';
import '../styles/Games.css';

const styles = theme => ({
  hide: { display: 'none' },
  show: { display: 'flex' },
  card: {
    width: 'auto',
    margin: '0px',
    display: 'inline-block',
  },

  dateFilter: {
    width: 'fit-content',
    height: '30px',
    padding: '10px 20px',
    fontFamily: 'Helvetica, sans-serif',
    fontWeight: '300',
    fontSize: '16px',
    border: '1px solid #aaa',
    borderRadius: '4px',
    margin: '5px 20px 5px 20px',
  },
  calendar: {
    zIndex: 20,
  },
  formControlSelect: {
    width: '100%',
    marginTop: theme.spacing(),
    marginLeft: theme.spacing(),
    marginRight: theme.spacing(),
  },
});

class Games extends React.Component {
  state = {
    logApi: null,
    dialogType: '',
    daySelected: null,

    gameDate: null,
    homeTeam: null,
    awayTeam: null,
    gameSelected: null,
    awayScore: 0,
    homeScore: 0,
    period: null,
    time: null,
    gameClosed: false,
    loading: false,
  };

  handleChange = (name, value) => {
    this.setState({ [name]: value });
  };

  cleanForm = () => {
    this.setState({
      gameDate: null,
      homeTeam: null,
      awayTeam: null,
      gameSelected: null,
      awayScore: 0,
      homeScore: 0,
      period: null,
      time: null,
      gameClosed: false,
    });
  };

  findTeamUniqueId(teamId) {
    const { teams } = this.props;
    for (const team of teams) {
      if (teamId && team._id.toString() === teamId.toString()) {
        return team._id;
      }
    }
    return '';
  }

  fillDialogForm = row => {
    this.setState({
      gameDate: row.scheduled,
      homeTeam: this.findTeamUniqueId(row.homeId),
      awayTeam: this.findTeamUniqueId(row.awayId),
      awayScore: _.get(row, 'awayScore', 0),
      homeScore: _.get(row, 'homeScore', 0),
      period: _.get(row, 'period', null),
      time: _.get(row, 'clock', null),
      gameClosed: _.get(row, 'gameClosed', false),
      gameSelected: row._id,
      dialogType: 'edit',
    });
  };

  checkTeamSelected = rowId => {
    return (this.state.homeTeam && rowId.toString() === this.state.homeTeam.toString()) ||
      (this.state.awayTeam && rowId.toString() === this.state.awayTeam.toString())
      ? true
      : false;
  };

  uploadFile = files => {
    const { leagueSelected } = this.props;

    this.setState({ loading: true });
    try {
      const { currentGroup, token } = store.getState().auth;

      const request = Request.post(`${BASE_URL}/sportsapi/scheduleimage`)
        .field('group', currentGroup._id)
        .field('leagueId', leagueSelected._id)
        .attach('file', files[0])
        .set('Authorization', token)
        .timeout(3600000);

      request.end((err, res) => {
        if (!err && res.statusCode === 201) {
          const file = JSON.parse(res.text);
          this.props.setScheduleImageUrl(file.url);
        }

        this.setState({ loading: false });
      });
    } catch (e) {
      console.log(e);
    }
  };

  removeFile() {
    this.setState({ loading: true });
    const { leagueSelected } = this.props;
    if (leagueSelected) {
      const leagueId = leagueSelected._id;
      const { currentGroup, token } = store.getState().auth;

      const request = Request.delete(`${BASE_URL}/sportsapi/scheduleimage`)
        .field('group', currentGroup._id)
        .field('leagueId', leagueId)
        .set('Authorization', token)
        .timeout(3600000);

      request.end((err, res) => {
        if (!err && res.statusCode === 202) {
          this.props.setScheduleImageUrl(null);
          this.setState({ loading: false });
        }
      });
    }
  }

  render() {
    const {
      classes,
      leagues,
      leagueSelected,
      teamSelected,
      gameEvents,
      games,
      teams,
      homePosition,
      updateCalendarEvents,
      getDailyEvents,
      createGame,
      confirmDeleteGame,
      changeFilter,
      editGame,
      dialogOpen,
      changeDialogState,
      updateErrorMessage,
      errorList,
      targetMonth,
      refresh,
    } = this.props;

    const localizer = momentLocalizer(moment);
    const size = 300;

    return (
      <div>
        <div
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
          }}
        >
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <LeagueTeamSorting
              league={leagueSelected ? leagueSelected._id : null}
              query={JSON.stringify({ active: true })}
              changeLeague={league => changeFilter({ league })}
              team={teamSelected}
              changeTeam={(team, clear) => (clear ? null : changeFilter({ team }))}
              disabled={this.state.daySelected ? true : false}
              key={leagueSelected ? leagueSelected._id : null}
            />
            <div>
              <div
                style={{
                  textAlign: 'center',
                }}
              >
                Schedule image
              </div>

              <div
                className="image-container"
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                  width: 200,
                  height: 200,
                  backgroundImage: `url(${this.props.scheduleImageUrl})`,
                  padding: `${size * 0.0618}px`,
                }}
              >
                {this.state.loading ? (
                  <Progress />
                ) : (
                  <Dropzone
                    className="dropzone"
                    accept={'image/jpeg, image/jpg, image/png, image/gif, '}
                    onDrop={this.uploadFile}
                  >
                    <UploadIcon
                      className="upload-icon"
                      style={{ fontSize: size * 0.15 }}
                    />
                    {this.props.scheduleImageUrl ? (
                      <div
                        className="bt-remove"
                        onClick={event => {
                          event.stopPropagation();
                          this.removeFile();
                        }}
                      >
                        <RemoveIcon />
                      </div>
                    ) : null}
                  </Dropzone>
                )}
              </div>
            </div>
          </div>

          <div
            style={{
              display: 'flex',
              flexWrap: 'wrap',
              justifyContent: 'flex-end',
            }}
            className={!this.state.daySelected ? classes.hide : classes.show}
          >
            <div
              style={
                this.state.daySelected
                  ? {
                      marginTop: '20px',
                    }
                  : { display: 'none' }
              }
            >
              <DatePicker
                popperClassName={classes.calendar}
                className={classes.dateFilter}
                selected={new Date(this.state.daySelected)}
                onChange={date => {
                  this.handleChange('daySelected', moment(date));
                  getDailyEvents(date);
                }}
                placeholderText="Click to select a date"
                dateFormat="MMMM d, yyyy"
                disabledKeyboardNavigation
              />
            </div>
            <Button
              variant="text"
              color="default"
              size="small"
              style={
                this.state.daySelected
                  ? {
                      marginTop: '20px',
                      marginRight: '20px',
                      border: '1px solid #DDD',
                      background: '#fafafa', //#e6e6e6
                    }
                  : { display: 'none' }
              }
              onClick={() => this.handleChange('daySelected', null)}
            >
              BACK To Calendar
            </Button>
            <Fab
              variant="extended"
              size="small"
              color="primary"
              aria-label="add"
              onClick={() => {
                this.handleChange('dialogType', 'create');
                changeDialogState(true);
              }}
              style={{ marginTop: '20px', paddingRight: '15px' }}
            >
              <MdAdd
                style={{
                  fontSize: '30px',
                  paddingRight: '5px',
                  fontWeight: 'bold',
                }}
              />
              Add new Game
            </Fab>
          </div>
        </div>

        <div style={this.state.daySelected ? { display: 'none' } : { marginTop: '20px' }}>
          <Calendar
            localizer={localizer}
            events={gameEvents}
            onSelectEvent={(event, e) => {
              this.handleChange('daySelected', event.start);
              getDailyEvents(event.start);
            }}
            views={['month', 'agenda']}
            startAccessor="start"
            endAccessor="end"
            style={{ height: 500 }}
            onNavigate={(date, view, action) => {
              updateCalendarEvents(moment(date));
            }}
            onDrillDown={(date, view, action) => {
              this.handleChange('daySelected', date);
              getDailyEvents(date);
            }}
          />
        </div>

        <div
          style={
            !this.state.daySelected
              ? { display: 'none' }
              : { marginTop: '20px', overflow: 'scroll-y' }
          }
        >
          <GamesTable
            confirmDeleteGame={confirmDeleteGame}
            games={games}
            daySelected={this.state.daySelected}
            fillDialogForm={this.fillDialogForm}
            changeDialogState={changeDialogState}
            leagueSelected={leagueSelected}
            updateCalendarEvents={updateCalendarEvents}
            targetMonth={targetMonth}
            getDailyEvents={getDailyEvents}
          />
        </div>

        <EditGameDialog
          open={dialogOpen}
          onClose={update => {
            changeDialogState(false);

            if (update) {
              refresh(this.state.daySelected);
            }
          }}
          gameId={this.state.dialogType === 'edit' && this.state.gameSelected}
          leagueId={_.get(leagueSelected, '_id')}
          date={this.state.daySelected}
        />

        <ModalRoot />
      </div>
    );
  }
}

export default withStyles(styles)(Games);
